import React, { useContext, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { useTranslation } from 'react-i18next';

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import { CenteredContent } from 'src/components/center_content';
import { CustomCircularProgress } from 'src/components/custom_circular_progress';
import { TextField } from 'src/components/text_field';
import { RouterStoreCtx } from 'src/store/router';
import { AuthStoreCtx } from 'src/store/auth';
import { MagicLinkStoreCtx } from './store';

import { useStyles } from './styles';

export default observer(() => {
    const {
        wrapper, loginTitle,
        button, title, buttonLabel,
        loadingButton, circularProgress
    } = useStyles({});

    const { t } = useTranslation();

    const {
        email, emailSetter,
        err, send, linkExpired,
        loginError, loginSent,
        emailValidate, loadingPage, pending
    } = useContext(MagicLinkStoreCtx);

    const { clearAppStartColor } = useContext(AuthStoreCtx);
    const { params } = useContext(RouterStoreCtx);

    useEffect(() => {
        clearAppStartColor();
    }, []);

    const textFieldError = err.email || [loginError];
    const isError = Boolean(err.email || loginError);

    if (loadingPage) {
        return (
            <CenteredContent>
                <CustomCircularProgress />
            </CenteredContent>
        );
    }

    if (params && toJS(params.token)) {
        return <CenteredContent><CustomCircularProgress/></CenteredContent>;
    }

    if (loginSent) {
        return (
            <CenteredContent>
                <div className={wrapper}>
                    <CenteredContent>
                        <Typography classes={{ root: title }} variant="h2">
                            {t('We’ve sent you an email to login.')}
                        </Typography>
                    </CenteredContent>
                    <CenteredContent>
                        <Typography classes={{ root: loginTitle }} variant="h3">
                            {t('A magic link has been sent to')} <strong>{email}</strong>. <br />
                            {t('Please click on the link in the email to log in.')}
                        </Typography>
                    </CenteredContent>
                </div>
            </CenteredContent>
        );
    }

    return (
        <CenteredContent>
            <div className={wrapper}>
                <CenteredContent>
                    <Typography classes={{ root: title }} variant="h2">
                        {
                            linkExpired
                                ? t('The login link to your assessment has expired')
                                : t('Welcome back!')
                        }
                    </Typography>
                </CenteredContent>
                <CenteredContent>
                    <Typography classes={{ root: loginTitle }} variant="h3">
                        {
                            linkExpired
                                ? t('Fill in your email below and we\'ll send you a new link to login.')
                                : t('Login to see your assessment status')
                        }
                    </Typography>
                </CenteredContent>
                <CenteredContent>
                    <div style={{ width: '500px' }}>
                        <TextField
                            value={email}
                            onChange={emailSetter}
                            errors={textFieldError}
                            error={isError}
                            onBlur={emailValidate}
                            placeholder={t('e.g mary@gmail.com')}
                            label={t('Your email')}
                        />
                    </div>
                </CenteredContent>
                <CenteredContent>
                    <Button
                        className={button}
                        color="primary"
                        variant="contained"
                        onClick={send}
                        disabled={pending}
                    >
                        {
                            pending
                                ? (
                                    <div className={loadingButton}>
                                        {t('Please wait...')}
                                        <CircularProgress size={18} className={circularProgress} />
                                    </div>
                                )
                                : t('Email me a link to login')
                        }
                    </Button>
                </CenteredContent>
            </div>
        </CenteredContent>
    );
});
